import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MbscDatepicker } from '@mobiscroll/angular';
import { TranslateService } from '@ngx-translate/core';
import moment, { Moment } from 'moment';
import { SharedDataService } from '../../service/shared-data/shared-data.service';
import { PlanningDataService } from '../../service/planning-data.service';

@Component({
  selector: 'app-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrl: './month-picker.component.scss',
})
export class MonthPickerComponent implements OnInit, OnChanges {
  @ViewChild('picker', { static: false }) pickerInst: MbscDatepicker;
  @Output() dateChanged = new EventEmitter<Date | null>(); // EventEmitter to emit date
  @Input() selMonth: Date;
  @Input() planningLoader: boolean = false;
  @Input() managerPlanningLoader: boolean = false;
  @Input('formSubmitted') formSubmitted: boolean = true;
  @Input('respComp') respComp: boolean = false; //month picker should be handled based on the response from parent component
  @Input('updateSharedPlanDate') updateSharedPlanDate: boolean = false; //whether date data in PlanningDataService should be updated on date change
  @Input('setDate') setDate: boolean = false;
  @Input('isManager') isManager: boolean = false;
  private _planLimitMonth: number;  
  private _dueDay: any;
  @Input('restrictMonthSelection') restrictMonthSelection: boolean = false;
  currentMonth: Date = new Date();
  date = new FormControl(moment());
  currentLanguage: string; //for providing real time translation for mat datepicker.
  formattedDateDisplay: string = moment().format('MMMM, YYYY'); // Display string
  normalizedMonthAndYear: Moment | Date
  datepicker?: MatDatepicker<Moment>
  @Input() 
  set planLimitMonth(value: number) {
    this._planLimitMonth = value; // Set the new value
  }

  get planLimitMonth(): number {
    return this._planLimitMonth; // Return the current value
  }
  @Input() 
  set dueDay(value: number) {
    this._dueDay = value; // Set the new value
  }

  get dueDay(): number {
    return this._dueDay; // Return the current value
  }
  constructor(
    private translateService: TranslateService,
    private dateAdapter: DateAdapter<Date>,
    private sharedDataService : SharedDataService,
    private planningDataService: PlanningDataService,
  ) {}
  ngOnInit(): void {

    // for providing translation to mat datepicker -starts here
    this.currentLanguage = this.translateService.currentLang;
    // if(this.restrictMonthSelection){
    //   this.getEnableMonth(this.planLimitMonth, this.dueDay); // 0 = January
    // }
    // else{
    //   this.enableMonthList = []
    // }
    // Set the initial locale for mat-datepicker
    this.dateAdapter.setLocale(this.currentLanguage);
    this.currentMonth = this.selMonth;
    this.updateFormattedDateDisplay(this.currentMonth);
    // Listen for language changes and update the datepicker's locale
    this.translateService.onLangChange.subscribe((event) => {
      this.currentLanguage = event.lang;
      this.dateAdapter.setLocale(this.currentLanguage);
      this.updateFormattedDateDisplay(this.currentMonth);
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.currentMonth = this.selMonth;
    // if(this.restrictMonthSelection){
    //   this.getEnableMonth(this.planLimitMonth, this.dueDay); // 0 = January
    // }
    // else{
    //   this.enableMonthList = []
    // }
    if(!this.planningDataService.getDatePickerData()){
      this.normalizedMonthAndYear = this.sharedDataService.curMonInMonPicker
    }
    else{
      this.normalizedMonthAndYear = this.planningDataService.getDatePickerData()
    }
    this.updateFormattedDateDisplay(this.currentMonth);
    if (changes['formSubmitted']) {
      if(this.formSubmitted){
        this. setMonthAndYear(
          this.normalizedMonthAndYear,
          this.datepicker
        ) 
      }
    }

  }
//   enableMonthList:any
//   getEnableMonth(planningLimitMonth: number, dueDay: number) {
//   const today = new Date();
//   const currentMonth = today.getMonth(); // 0 = January
//   const currentYear = today.getFullYear();
//   const currentDate = today.getDate();
    
//   // Compute how many months to include based on the planning limit
//   const months: { month: number; year: number; enableMonth: boolean }[] = [];

//   for (let i = 0; i < planningLimitMonth; i++) {
//     const month = (currentMonth + i) % 12;
//     const year = currentYear + Math.floor((currentMonth + i) / 12);
//     let enableMonth = true;
//     // For the last allowed month, enable only after dueDay
//     if (i === planningLimitMonth - 1 && currentDate <= dueDay) {
//       enableMonth = false;
//     }
//     months.push({ month, year, enableMonth });
//   }

//   this.enableMonthList = months
//   // Return whether the current month itself is enabled (you can modify this line based on your need)
// }

  prevMonth(): void {
    this.currentMonth = new Date(
      this.currentMonth.getFullYear(),
      this.currentMonth.getMonth() - 1,
      1 // Set day to 1 to ensure it's the first day of the month
    );
    const ctrlValue = this.date.value ?? moment();
    this.sharedDataService.curMonInMonPicker =  new Date(
      ctrlValue.startOf('month').toDate().getFullYear(),
      ctrlValue.startOf('month').toDate().getMonth() - 1,
      1 // Set day to 1 to ensure it's the first day of the month
    );
    // this.setMonthAndYear(this.currentMonth);
    if(this.updateSharedPlanDate){
      this.planningDataService.setDatePickerData(this.sharedDataService.curMonInMonPicker)
    }
    this.setMonthAndYear(this.sharedDataService.curMonInMonPicker);
  }

//   isPrevMonthEnabled(): boolean {
//   if (!this.enableMonthList?.length) return false;

//   const prev = new Date(this.currentMonth);
//   prev.setMonth(this.currentMonth.getMonth() - 1);

//   const prevMonth = prev.getMonth();
//   const prevYear = prev.getFullYear();

//   const match = this.enableMonthList.find(
//     (m:any) => m.month === prevMonth && m.year === prevYear
//   );

//   // ✅ If month not found in array, still allow navigation backward
//   if (!match) return true;

//   return match.enableMonth;
// }

//   //check whether the next button in date field should be enabled i multi department planning view
//   isNextMonthEnabled(): boolean {
//     if (!this.restrictMonthSelection) return true;
//     if (!this.enableMonthList?.length) return true;

//     const next = new Date(this.currentMonth);
//     next.setMonth(this.currentMonth.getMonth() + 1);

//     const nextMonth = next.getMonth();
//     const nextYear = next.getFullYear();
//     const nextDate = new Date(nextYear, nextMonth, 1);

//     // Get the first and last months in the enableMonthList
//     const firstMonthObj = this.enableMonthList[0];
//     const lastMonthObj = this.enableMonthList[this.enableMonthList.length - 1];
//     const firstMonthDate = new Date(firstMonthObj.year, firstMonthObj.month, 1);
//     const lastMonthDate = new Date(lastMonthObj.year, lastMonthObj.month, 1);

//     // ✅ Allow navigation for months before the first allowed month
//     if (nextDate < firstMonthDate) return true;

//     // ❌ Disable navigation for months after the last listed month
//     if (nextDate > lastMonthDate) return false;

//     // 🔍 Find the month in the enableMonthList
//     const match = this.enableMonthList.find(
//       (m: any) => m.month === nextMonth && m.year === nextYear
//     );

//     // ❌ If the month is missing in the list but is within range, assume restricted
//     if (!match) return false;

//     // ✅ Respect enableMonth flag
//     return match.enableMonth;
//   }
//   //identify the months that should be enabled in multi department planning sheet view
//   filterDate = (date: Date | null): boolean => {
//     if (!date || !this.enableMonthList?.length) return true;

//     const month = date.getMonth();
//     const year = date.getFullYear();
//     const dateToCheck = new Date(year, month, 1);

//     const first = this.enableMonthList[0];
//     const firstDate = new Date(first.year, first.month, 1);

//     // ✅ Before first month → always enabled
//     if (dateToCheck < firstDate) return true;

//     // 🔍 Find the corresponding month in enableMonthList
//     const match = this.enableMonthList.find(
//       (m: any) => m.month === month && m.year === year
//     );

//     // If found → follow enableMonth flag
//     if (match) return match.enableMonth;

//     // If not listed but after first month → disable by default
//     return false;
//   };


  nextMonthClick(): void {
    this.currentMonth = new Date(
      this.currentMonth.getFullYear(),
      this.currentMonth.getMonth() + 1,
      1 // Set day to 1 to ensure it's the first day of the month
    );
    const ctrlValue = this.date.value ?? moment();
    this.sharedDataService.curMonInMonPicker =  new Date(
      ctrlValue.startOf('month').toDate().getFullYear(),
      ctrlValue.startOf('month').toDate().getMonth() + 1,
      1 // Set day to 1 to ensure it's the first day of the month
    );
    
    if(this.updateSharedPlanDate){
      this.planningDataService.setDatePickerData(this.sharedDataService.curMonInMonPicker)
    }
    this.setMonthAndYear(this.sharedDataService.curMonInMonPicker);
  }

  setMonthAndYear(
    normalizedMonthAndYear: Moment | Date,
    datepicker?: MatDatepicker<Moment>, action?:string
  ) {    
    if(this.respComp){
      // this.normalizedMonthAndYear = normalizedMonthAndYear
      if(action === 'calendar-sel'){
        this.sharedDataService.curMonInMonPicker = normalizedMonthAndYear
        
        if(this.updateSharedPlanDate){
          this.planningDataService.setDatePickerData(normalizedMonthAndYear)
        }
      }
      // this.normalizedMonthAndYear = this.sharedDataService.curMonInMonPicker
      this.normalizedMonthAndYear = this.planningDataService.getDatePickerData()
      this.datepicker = datepicker
      if(this.formSubmitted){
        const date = new Date(this.sharedDataService.curMonInMonPicker);
        const momentDate = moment(date);
        this.date.setValue(momentDate);
        this.setDateValue(normalizedMonthAndYear, datepicker)
      }
      else{
      //  this.dateChanged.emit(this.sharedDataService.curMonInMonPicker); // Emit the full date to the parent component
       this.dateChanged.emit(this.planningDataService.getDatePickerData()); // Emit the full date to the parent component
       datepicker ? datepicker.close() : null;
      }
    }
    else{
      this.setDateValue(normalizedMonthAndYear, datepicker)
    }

  }

  setDateValue( normalizedMonthAndYear: Moment | Date,
    datepicker?: MatDatepicker<Moment>){
    const ctrlValue = this.date.value ?? moment();
    let selDate = ctrlValue;
    // Convert to Moment if necessary
    const normalizedMoment = moment.isMoment(normalizedMonthAndYear)
      ? normalizedMonthAndYear
      : moment(normalizedMonthAndYear);

    ctrlValue.month(normalizedMoment.month());
    ctrlValue.year(normalizedMoment.year());
    this.date.setValue(ctrlValue);
    this.currentMonth = selDate.startOf('month').toDate();
    this.updateFormattedDateDisplay(this.currentMonth);
    this.onDateSet(this.currentMonth);
    datepicker ? datepicker.close() : null;
  }


  private updateFormattedDateDisplay(date: Date): void {
    const month = date.toLocaleString(this.currentLanguage, { month: 'long' }); // Translate month
    const year = date.getFullYear();
    // this.planningDataService.setDateData({selectedYear:year, selectedMonth:date.getMonth() + 1})
    this.formattedDateDisplay = `${month}, ${year}`;
  }

  onDateSet(event: any): void {
    let selectedDate = event; // Get the date from the event
    const firstDayOfMonth = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      1
    ); // Set the day as the first day of the month

    this.currentMonth = firstDayOfMonth;
    // this.sharedDataService.selDateInPlanning = this.currentMonth;
    
    if(this.updateSharedPlanDate){
      this.planningDataService.setDatePickerData(this.currentMonth)
    }
    this.dateChanged.emit(this.currentMonth); // Emit the full date to the parent component
  }

  openMonthYearPicker(datepicker: MatDatepicker<Moment>) {
    if (this.planningLoader || this.managerPlanningLoader) {
     return; // do nothing while loading
    }
    datepicker.open();
  }
}
